import React, {useContext, useState, useRef, useLayoutEffect, useEffect} from 'react'
import {Link, useLocation} from 'react-router-dom'
import {LangContext} from '../../context/lang-context'
import logo from '../../assets/images/logo-retail24.png'
import logoSm from '../../assets/images/logo-retail24-sm.png'
import "./style.css"

const Sidebar = ({width, navlinks}) => {
    const location = useLocation()
    const currentPath = window.location.pathname.slice(10)
    const {TRL_Pack} = useContext(LangContext)
    const scrollRef = useRef(null)
    const [sidebarReady, setSidebarReady] = useState(false)
    const SIDEBAR_SCROLL_KEY = 'sidebar_scroll_top'
    const links = Array.isArray(navlinks) ? navlinks : []

    const saveSidebarScroll = () => {
        const el = scrollRef.current
        if (!el) return
        sessionStorage.setItem(SIDEBAR_SCROLL_KEY, String(el.scrollTop))
    }

    useEffect(() => {
        setSidebarReady(false)

        const timeout = setTimeout(() => {
            setSidebarReady(true)
        }, 350)

        return () => clearTimeout(timeout)
    }, [links.length, width])

    useLayoutEffect(() => {
        const el = scrollRef.current
        if (!el) return
        const saved = sessionStorage.getItem(SIDEBAR_SCROLL_KEY)
        if (saved == null) return
        const top = parseInt(saved, 10)
        if (!Number.isNaN(top)) el.scrollTop = top
    }, [location.pathname, width, sidebarReady])

    const ListItem = ({icon, text, path, group, onClick}) => (
        <>
            {width === 'md' ? (
                <li className="mb-3 mx-2">
                    {path ? (
                        <Link
                            to={path}
                            onClick={saveSidebarScroll}
                            className="nav-link d-flex align-items-center text-center text-dark btn btn-link p-1"
                        >
                            {group != null ? (
                                    <i className={`mr-3 ${icon}`} style={{marginLeft: 20, fontSize: '1.125em'}}/>) :
                                (<i className={`mr-3 ${icon}`} style={{width: 25, fontSize: '1.125em'}}/>)}
                            <span className=
                                      {(currentPath === path) ?
                                          "font-weight-bolder" :
                                          "font-weight-normal"}
                                  style={{textAlign: "start"}}
                            >{text}</span>
                        </Link>
                    ) : (
                        <div
                            onClick={(e) => {
                                saveSidebarScroll()
                                if (onClick) onClick(e)
                            }}
                            className="nav-link d-flex align-items-center text-center text-dark btn btn-link p-1"
                        >

                            <i className={`mr-3 ${icon}`} style={{width: 25, fontSize: '1.125em'}}/>
                            <span className="font-weight-normal">{text}</span>
                        </div>
                    )}
                </li>
            ) : (
                <li className="py-2 text-center lista">
                    {path ? (
                        <Link
                            to={path}
                            onClick={saveSidebarScroll}
                            className="nav-link d-flex flex-column text-dark btn btn-link p-1"
                        >
                            <i className={`${icon} mb-1`} style={{fontSize: '1.25em'}}/>
                            <span className="mt-1 small text-truc">{text}</span>
                        </Link>
                    ) : (
                        <div
                            onClick={(e) => {
                                saveSidebarScroll()
                                if (onClick) onClick(e)
                            }}
                            className="nav-link d-flex flex-column text-dark btn btn-link p-1"
                        >
                            <i className={`${icon} mb-1`} style={{fontSize: '1.25em'}}/>
                            <span className="mt-1 small text-truc">{text}</span>
                        </div>
                    )}
                </li>
            )}
        </>
    )

    let list = []
    let machineList = []
    const [collapseMachine, setCollapseMachine] = useState(false)
    let warehouseList = []
    const [collapseWarehouse, setCollapseWarehouse] = useState(false)
    let raportList = []
    const [collapseRaport, setCollapseRaport] = useState(false)
    let configurationList = []
    const [collapseConfiguration, setCollapseConfiguration] = useState(false)

    const handleClick = (type) => {
        switch (type) {
            case 'machine':
                setCollapseMachine(!collapseMachine)
                break
            case 'warehouse':
                setCollapseWarehouse(!collapseWarehouse)
                break
            case 'raport':
                setCollapseRaport(!collapseRaport)
                break
            case 'configuration':
                setCollapseConfiguration(!collapseConfiguration)
                break
            default:
                break
        }
    }

    const GroupItem = ({text, icon, type, collapsed}) => {

        return (
            <>
                <li className="mb-3 mx-2">
                    {width === 'md' ? (
                            <Link
                                onClick={() => {
                                    saveSidebarScroll()
                                    handleClick(type)
                                }}
                                className="nav-link d-flex align-items-center text-center text-dark btn btn-link p-1"
                            >
                                <i className={`mr-3 ${icon}`}
                                   style={{width: 25, fontSize: '1.125em'}}/>
                                <span className=
                                          "font-weight-normal"
                                >{text} </span>
                                {collapsed ? (<span className="fas fa-ellipsis-h ml-auto"></span>) : (
                                    <span className="fas fa-ellipsis-v ml-auto"></span>)}

                            </Link>
                        ) :
                        (
                            <Link
                                onClick={() => {
                                    saveSidebarScroll()
                                    handleClick(type)
                                }}
                                className="nav-link d-flex flex-column text-dark btn btn-link p-1"
                            >
                                <i className={`mb-1 ${icon}`}
                                   style={{fontSize: '1.25em'}}/>
                                <span className=
                                          "mt-1 small"
                                >{text} </span>
                            </Link>
                        )}
                </li>
            </>
        )
    }

    return (
        <div
            className="sidebar d-none d-lg-block sticky-top shadow bg-aqua-dark"
            style={{
                backgroundColor: "#C5D8FF",
                width: width === 'md' ? 250 : 100,
                minWidth: width === 'md' ? 250 : 100,
                zIndex: 1,
            }}
        >
            <div
                className="sidebar-img d-flex align-items-center justify-content-center bg-aqua-dark"
                style={{
                    height: 75,
                    minHeight: 75,
                    backgroundColor: 'rgba(0, 0, 0, 0.02)',
                    position: 'relative',
                }}
            >
                <img
                    src={logo}
                    alt="logo duże"
                    style={{
                        height: 65,
                        opacity: width === 'md' ? 1 : 0,
                        position: 'absolute',
                    }}
                />
                <img
                    src={logoSm}
                    alt="logo małe"
                    style={{
                        height: 50,
                        opacity: width === 'md' ? 0 : 1,
                        position: 'absolute',
                    }}
                />
            </div>

            <ul
                ref={scrollRef}
                onScroll={saveSidebarScroll}
                className="list-group list-group-flush pt-3 px-2 list-unstyled overflow-mouse-focus custom-scroll"
                style={{
                    maxHeight: 'calc(100vh - 75px)',
                    opacity: sidebarReady ? 1 : 0,
                    pointerEvents: sidebarReady ? 'auto' : 'none',
                }}
            >
                {process.env.REACT_APP_LOCAL_DB === "false" && !sessionStorage.getItem("isMobile") && (
                    <ListItem text={TRL_Pack.navbar.start} path={'/start'} icon={'fas fa-play-circle'}></ListItem>
                )}

                {links.map((navlink, idx) => (
                    navlink.group === 'machine' && (machineList.push(<ListItem key={idx} {...navlink} />)),
                    navlink.group === 'warehouse' && (warehouseList.push(<ListItem key={idx} {...navlink} />)),
                    navlink.group === 'raport' && (raportList.push(<ListItem key={idx} {...navlink} />)),
                    navlink.group === 'configuration' && (configurationList.push(<ListItem key={idx} {...navlink} />)),
                    navlink.group === undefined && (list.push(<ListItem key={idx} {...navlink} />)),
                        null
                ))}
                {machineList.length > 0 && (
                    <GroupItem text={"Maszyny"} type={'machine'} collapsed={collapseMachine} icon={'fas fa-tablet-alt'}
                               onClick={() => setCollapseMachine(!collapseMachine)}/>)}
                {collapseMachine ? (machineList) : (null)}

                {warehouseList.length > 0 && (
                    <GroupItem text={"Magazyn"} type={'warehouse'} collapsed={collapseWarehouse}
                               icon={'fas fa-tablet-alt'} onClick={() => setCollapseWarehouse(!collapseWarehouse)}/>)}
                {collapseWarehouse ? (warehouseList) : (null)}

                {raportList.length > 0 && (
                    <GroupItem text={"Raporty"} type={'raport'} collapsed={collapseRaport} icon={'fas fa-tablet-alt'}
                               onClick={() => setCollapseRaport(!collapseRaport)}/>)}
                {collapseRaport ? (raportList) : (null)}

                {configurationList.length > 0 && (
                    <GroupItem text={"Konfiguracja"} type={'configuration'} collapsed={collapseConfiguration}
                               icon={'fas fa-tablet-alt'}
                               onClick={() => setCollapseConfiguration(!collapseConfiguration)}/>)}
                {collapseConfiguration ? (configurationList) : (null)}
                {list}
            </ul>
        </div>
    )
}

export default Sidebar